import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DetailsIcon from '@material-ui/icons/Details';
import EditIcon from '@material-ui/icons/Edit';
import LockIcon from '@material-ui/icons/Lock';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Button from '@material-ui/core/Button';
import { ConfirmAction } from '../../../dialogs'
import UserApi from '../../../../libs/EdgeVMSCloudApi/Users'
import { SERVICES, OPERATIONS } from '../../../../constants/permissions'

const useStyles = theme => ({
  actionsDropDown: {
    marginRight: theme.spacing(6),
  },
  actionsMenuIcon: {
    minWidth: theme.spacing(4),
  },
});

function DetailsAction(props) {
  const { userId, session, federated, temporary, disabled, dense, dropDownVariant } = props
  const hasReadPermission = session.permissions[SERVICES.USER][OPERATIONS.READ]
  const hasUpdatePermission = !federated && session.permissions[SERVICES.USER][OPERATIONS.UPDATE]

  if (dropDownVariant || !(hasReadPermission || hasUpdatePermission) || temporary) {
    return null
  }

  return (
    <Fragment>
      <Tooltip title={hasUpdatePermission ? "Edit" : "Details"}>
        <IconButton
          disabled={disabled}
          size={dense ? 'small' : 'medium'}
          onClick={() => props.history.push('/mainmenu/admin/users/details/' + userId, { originLocation: window.location.toString() })}
        >
          { hasUpdatePermission ?
            <EditIcon fontSize={dense ? 'small' : 'default'}/> :
            <DetailsIcon fontSize={dense ? 'small' : 'default'}/>
          }
        </IconButton>
      </Tooltip>
    </Fragment>
  )
}

class ResetPasswordAction extends Component {
  onClick = () => {
    if (this.props.closeMenu){
      this.props.closeMenu()
    }

    if (this.props.userId) {
      this.props.history.push('/mainmenu/admin/users/resetpassword/' + this.props.userId, { originLocation: window.location.toString() })
    }
  }

  render () {
    const { session, federated, temporary, classes, disabled, dense, dropDownVariant } = this.props;

    if (federated || temporary || !session.permissions[SERVICES.USER][OPERATIONS.UPDATE])
    {
      return null
    }

    return (
      <Fragment>
        { dropDownVariant ? (
          <MenuItem onClick={this.onClick}>
            <ListItemIcon className={classes.actionsMenuIcon}>
              <LockIcon fontSize='small' />
            </ListItemIcon>
            Reset Password
          </MenuItem>
        ) : (
          <Tooltip title="Reset Password">
            <IconButton
              disabled={disabled}
              size={dense ? 'small' : 'medium'}
              onClick={this.onClick}
            >
              <LockIcon fontSize={dense ? 'small' : 'default'} />
            </IconButton>
          </Tooltip>
        )}
      </Fragment>
    )
  }
}


class DeleteAction extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showActionProgress: false,
      confirmDeleteActionOpen: false,
    }

    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  onDeleteActionClick() {
    if (this.props.closeMenu){
      this.props.closeMenu()
    }

    this.setState({showActionProgress: false})
    this.setState({confirmDeleteActionOpen: true})
  }

  async DeleteActionCallback(userAnswer, toDelete) {
    if (userAnswer && userAnswer === 'ok' && toDelete) {
      this.setState({showActionProgress: true})
      const response = await UserApi.DeleteUser(this.signal, toDelete)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      this.setState({confirmDeleteActionOpen: false})

      // Call this last because it will probably result in the component being unmounted.
      if (this.props.onConfirmDelete) {
        await this.props.onConfirmDelete();
      }
    } else {
      this.setState({confirmDeleteActionOpen: false})
    }
  }

  render() {
    const { session, classes, disabled, dense, dropDownVariant, temporary } = this.props;

    if (!session.permissions[SERVICES.USER][OPERATIONS.DELETE])
    {
      return null
    }

    return (
      <Fragment>
        { dropDownVariant ? (
          <MenuItem onClick={this.onDeleteActionClick.bind(this)}>
            <ListItemIcon className={classes.actionsMenuIcon}>
              <DeleteForeverIcon fontSize='small' />
            </ListItemIcon>
            Delete Forever
          </MenuItem>
        ) : (
          <Tooltip title="Delete Forever">
            <IconButton
              disabled={disabled}
              size={dense ? 'small' : 'medium'}
              onClick={this.onDeleteActionClick.bind(this)}
            >
              <DeleteForeverIcon fontSize={dense ? 'small' : 'default'} />
            </IconButton>
          </Tooltip>
        )}

        <ConfirmAction
          title="Delete User ?"
          open={this.state.confirmDeleteActionOpen}
          showProgress={this.state.showActionProgress}
          progressMsg="Processing request to delete user..."
          actionCallback={this.DeleteActionCallback.bind(this)}
          callbackContext={this.props.userId}
        >
          Are you sure you want to permanently delete this user?<br/>
          {temporary ? <Fragment>You will not be able to share the associated case using this temporary user anymore, and you will not be able to create another temporary user for this case! <br/> </Fragment> : null}
          This operation is IRREVERSIBLE!
        </ConfirmAction>
      </Fragment>
    )
  }
}

class UserActions extends Component {
  constructor (props) {
    super(props)

    this.state = {
      userMenuAnchor: null,
    }
  }

  closeMenu = () => {
    this.setState({userMenuAnchor: null})
  }

  render () {
    const { session, classes, disabled,  dropDownVariant } = this.props
    const { userMenuAnchor } = this.state

    if ((!session.permissions[SERVICES.USER][OPERATIONS.READ] || dropDownVariant) &&
         !session.permissions[SERVICES.USER][OPERATIONS.UPDATE] &&
         !session.permissions[SERVICES.USER][OPERATIONS.DELETE]) {
      if (dropDownVariant) {
        return null
      } else {
        return "None"
      }
    }

    if (dropDownVariant) {
      return (
        <Fragment>
          <Button
            disabled={disabled}
            className={classes.actionsDropDown}
            variant='outlined'
            color="inherit"
            endIcon={Boolean(userMenuAnchor) ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
            onClick={(event) => this.setState({userMenuAnchor: event.currentTarget})}
          >
            ACTIONS
          </Button>
          <Menu
            id="actions-menu"
            anchorEl={userMenuAnchor}
            keepMounted
            TransitionComponent={Fade}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={Boolean(userMenuAnchor)}
            onClose={this.closeMenu}
          >
            <ResetPasswordAction {...this.props} closeMenu={this.closeMenu}/>
            <DeleteAction {...this.props} closeMenu={this.closeMenu}/>
          </Menu>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <DetailsAction {...this.props}/>
          <ResetPasswordAction {...this.props}/>
          <DeleteAction {...this.props}/>
        </Fragment>
      )
    }
  }
}

export default withRouter(withStyles(useStyles)(UserActions))
